(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hk-color-browser"] && !Shopify.designMode) return;
  try {
    (() => {
    function initializeOriginalColors() {
      const grid = document.querySelector('.hk-color-card-grid');
      const button = document.getElementById('hk-browse-original-colors');
      const config = document.getElementById('hk-color-browser-config');
      if (!grid || !button || !config || grid.dataset.browseReady) return;
      grid.dataset.browseReady = 'true';
      grid.id = 'hk-original-color-grid';
      if (config.dataset.handle === 'richardson-112-trucker-hat') {
        const featured = ['Black','Black/Charcoal','Black/White','Charcoal/White','Heather Grey/Black','Heather Grey/White','Loden','Charcoal/Black','Navy'];
        const cards = Array.from(grid.children);
        featured.forEach(name => {
          const card = cards.find(item => item.dataset.variantTitle === name);
          if (card) grid.append(card);
        });
        cards.filter(card => !featured.includes(card.dataset.variantTitle)).forEach(card => grid.append(card));
      }
      const items = Array.from(grid.children);
      if (items.length <= 9) return;
      const rest = items.slice(9);
      rest.forEach(item => item.hidden = true);
      grid.after(button);
      button.hidden = false;
      const browseLabel = button.textContent;
      let expanded = false;
      button.addEventListener('click',() => {
        expanded = !expanded;
        rest.forEach(item => {
          const selected = Array.from(item.querySelectorAll('.hk-color-qty-display')).some(input => Number(input.value) > 0);
          item.hidden = !expanded && !selected;
        });
        button.setAttribute('aria-expanded',String(expanded));
        button.textContent = expanded ? config.dataset.collapse : browseLabel;
        if (expanded) {
          const target = rest[0].querySelector('button:not([disabled]),input:not([disabled]),summary');
          target?.focus();
        } else {
          button.focus({preventScroll:true});
          button.scrollIntoView({block:'center',behavior:'smooth'});
        }
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initializeOriginalColors);
    else initializeOriginalColors();
  })();
  } catch(e) { console.error(e); }
})();

})();
